'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.subnav = twentyninetimes.subnav || function () {

    function init() {
        subnav();
    }

    function subnav() {
        if (document.getElementById('dynamic-nav')) {
            const nav = document.querySelector('.block-theme-header__navigation');
            const menuItems = nav.querySelector('.menu-items');
            const dropdownMenu = nav.querySelector('.dropdown-menu');
            const dropdownButton = dropdownMenu.querySelector('.dropdown-button');
            const dropdownContent = dropdownMenu.querySelector('.dropdown-content');

            function updateMenu() {
                const navWidth = nav.offsetWidth;
                let itemsWidth = dropdownMenu.offsetWidth; // Start with dropdown width to account for it
                let shouldShowDropdown = false;

                // Reset the dropdown
                dropdownContent.innerHTML = '';
                dropdownMenu.style.display = 'none';

                // Loop through menu items and check width
                Array.from(menuItems.children).forEach((item) => {
                    item.style.display = ''; // Reset display
                    itemsWidth += item.offsetWidth;

                    if (itemsWidth > navWidth) {
                        shouldShowDropdown = true;
                        dropdownContent.appendChild(item.cloneNode(true)); // Clone overflowing items to dropdown
                        item.style.display = 'none'; // Hide original item
                    }
                });

                // Show the dropdown if necessary
                if (shouldShowDropdown) {
                    dropdownMenu.style.display = 'block';
                }
            }

            // Run on load
            updateMenu();

            // Recalculate on window resize
            window.addEventListener('resize', updateMenu);

            // Toggle dropdown on button click
            dropdownButton.addEventListener('click', function (event) {
                event.stopPropagation(); // Prevent click from propagating to document
                dropdownContent.style.display = dropdownContent.style.display === 'block' ? 'none' : 'block';
            });

            // Prevent dropdown from closing when interacting with its content
            dropdownContent.addEventListener('click', function (event) {
                event.stopPropagation(); // Prevent click from propagating to document
            });

            // Close dropdown when clicking outside
            document.addEventListener('click', function (event) {
                if (!dropdownMenu.contains(event.target)) {
                    dropdownContent.style.display = 'none';
                }
            });
        }
    }

    return {
        init: init
    };

}();